/** @format */

import React from "react";
import { Box, Button, Typography } from "@mui/material";
import DownloadRoundedIcon from "@mui/icons-material/DownloadRounded";
import { resolveExportUrl } from "./propilotApi";

const ExportButton = ({ response }) => {
  const { download_url, file_id, filename, record_count } = response || {};
  const url = resolveExportUrl(download_url, file_id);
  if (!url) return null;

  return (
    <Box
      sx={{
        mt: 1.5,
        p: 1.5,
        backgroundColor: "#ecfdf5",
        border: "1px solid #a7f3d0",
        borderRadius: "10px",
        display: "flex",
        alignItems: "center",
        gap: 1.5,
      }}
    >
      <Button
        variant="contained"
        startIcon={<DownloadRoundedIcon />}
        onClick={() => window.open(url, "_blank", "noopener")}
        sx={{
          backgroundColor: "#10b981",
          color: "#fff",
          textTransform: "none",
          fontWeight: 600,
          fontSize: 13,
          borderRadius: "8px",
          boxShadow: "none",
          flexShrink: 0,
          "&:hover": { backgroundColor: "#059669", boxShadow: "none" },
        }}
      >
        Download CSV
      </Button>
      <Box sx={{ flex: 1, minWidth: 0 }}>
        {filename && (
          <Typography
            sx={{
              fontSize: 12,
              fontWeight: 600,
              color: "#065f46",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
            title={filename}
          >
            {filename}
          </Typography>
        )}
        {record_count != null && (
          <Typography sx={{ fontSize: 11, color: "#047857" }}>
            {Number(record_count).toLocaleString()} records
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default ExportButton;
